var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-page-content-wrapper copilot-prompts-page" },
    [
      _c("div", { staticClass: "page-header" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("copilotPrompts.pageTitle"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("copilotPrompts.pageSubtitle")) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.sections, function (section) {
        return _c("div", { key: section.key, staticClass: "cps" }, [
          _c("div", { staticClass: "cps__head" }, [
            _c("i", { staticClass: "material-icons" }, [
              _vm._v(_vm._s(section.icon)),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t(section.labelKey)))]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cps__grid" },
            _vm._l(section.items, function (def) {
              return _c(
                "div",
                {
                  key: def.key,
                  staticClass: "cps__card",
                  on: {
                    click: function ($event) {
                      return _vm.openEditor(def)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "cps__card-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v(_vm._s(def.icon)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cps__card-text" }, [
                    _c("span", { staticClass: "cps__card-title" }, [
                      _vm._v(_vm._s(_vm.$t(def.labelKey))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cps__card-desc" }, [
                      _vm._v(_vm._s(_vm.$t(def.descriptionKey))),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ])
      }),
      _vm._v(" "),
      _vm.editModal.visible
        ? _c(
            "Modal2",
            {
              attrs: {
                design: "v3",
                large: true,
                showFooter: false,
                showTitle: false,
              },
              on: { cancel: _vm.closeEditor },
            },
            [
              _c("div", { staticClass: "cpm" }, [
                _c("div", { staticClass: "cpm__header" }, [
                  _c("div", { staticClass: "cpm__header-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v(_vm._s(_vm.editModal.def.icon)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "cpm__header-title" }, [
                      _vm._v(_vm._s(_vm.$t(_vm.editModal.def.labelKey))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cpm__header-desc" }, [
                      _vm._v(_vm._s(_vm.$t(_vm.editModal.def.descriptionKey))),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "cpm__body" }, [
                  _c(
                    "div",
                    { staticClass: "cpm__editor-pane" },
                    [
                      _c("div", { staticClass: "cpm__editor-label" }, [
                        _vm._v(
                          _vm._s(_vm.$t("copilotPrompts.systemPromptLabel"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("CoPilotPromptEditor", {
                        ref: "promptEditor",
                        attrs: { value: _vm.editModal.value },
                        on: { input: _vm.onEditorInput },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.currentTree.length
                    ? _c("div", { staticClass: "cpm__attr-pane" }, [
                        _c("div", { staticClass: "cpm__attr-title" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("data_object"),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("copilotPrompts.variablesTitle")) +
                              "\n                    "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "cpm__attr-hint" }, [
                          _vm._v(
                            _vm._s(_vm.$t("copilotPrompts.variablesHint"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "cpm__attr-tree" },
                          _vm._l(_vm.currentTree, function (group) {
                            return _c(
                              "div",
                              { key: group.key, staticClass: "cpm__grp" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "cpm__grp-head",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleGroup(group.key)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass:
                                          "material-icons cpm__grp-arrow",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.openGroups[group.key]
                                              ? "expand_more"
                                              : "chevron_right"
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    group.icon
                                      ? _c(
                                          "i",
                                          {
                                            staticClass:
                                              "material-icons cpm__grp-icon",
                                          },
                                          [_vm._v(_vm._s(group.icon))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(group.label))]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.openGroups[group.key]
                                  ? _c(
                                      "div",
                                      { staticClass: "cpm__grp-items" },
                                      _vm._l(group.children, function (item) {
                                        return _c(
                                          "div",
                                          { key: "item-" + item.key },
                                          [
                                            !item.children
                                              ? _c(
                                                  "a-tooltip",
                                                  {
                                                    attrs: {
                                                      title: item.description,
                                                      placement: "left",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cpm__leaf",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.insertAttr(
                                                              item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "cpm__leaf-name",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.label)
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  { staticClass: "cpm__sub" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "cpm__sub-head",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleGroup(
                                                              item.key
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "material-icons cpm__grp-arrow",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.openGroups[
                                                                  item.key
                                                                ]
                                                                  ? "expand_more"
                                                                  : "chevron_right"
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        item.icon
                                                          ? _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons cpm__sub-icon",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.icon
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(item.label)
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.openGroups[item.key]
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "cpm__sub-items",
                                                          },
                                                          _vm._l(
                                                            item.children,
                                                            function (child) {
                                                              return _c(
                                                                "a-tooltip",
                                                                {
                                                                  key: child.key,
                                                                  attrs: {
                                                                    title:
                                                                      child.description,
                                                                    placement:
                                                                      "left",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "cpm__leaf",
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.insertAttr(
                                                                              child
                                                                            )
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "cpm__leaf-name",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              child.label
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                ),
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "cpm__footer" },
                  [
                    _c("div", { staticStyle: { flex: "1" } }),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { ghost: true },
                        on: { click: _vm.closeEditor },
                      },
                      [_vm._v(_vm._s(_vm.$t("copilotPrompts.cancel")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        attrs: { primary: true, disabled: _vm.saving },
                        on: { click: _vm.savePrompt },
                      },
                      [
                        _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            staticStyle: { "font-size": "15px" },
                          },
                          [_vm._v("save")]
                        ),
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.saving
                                ? _vm.$t("copilotPrompts.saving")
                                : _vm.$t("copilotPrompts.save")
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }